<template>
  <article class="page page-orders page-payment">
    <section class="container-padding">
      <h1>Payment Successful</h1>

      <FontAwesomeIcon
        :icon="faCheckCircle"
        class="success mb-10"
      />

      <p>Thank you for your purchase! Your payment has been processed successfully.</p>
      <p>A confirmation email with the details of your transaction has been sent to your email address.</p>

      <AppLink
        :to="{ name: 'app_order_details', params: { order: route.params.order } }"
        class="btn btn-solid btn-secondary"
      >
        Access my photos
      </AppLink>
    </section>

    <AppCopyRightInfo />
  </article>
</template>

<script setup>
import { useRoute } from 'vue-router';

import { AppCopyRightInfo, AppLink } from '@/components/app';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';

const route = useRoute();

</script>
